import type { SVGProps } from 'react'

const SvgCheckIndeterminateSmall = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    height="1em"
    viewBox="0 0 18 18"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 0h18v18H0z" fill="none" />
    <path d="M4.348 9.853V8.147h9.304v1.706z" fill="inherit" />
  </svg>
)

export default SvgCheckIndeterminateSmall
